import { render, staticRenderFns } from "./vc-switch.vue?vue&type=template&id=08ff97c9&scoped=true&"
import script from "./vc-switch.vue?vue&type=script&lang=js&"
export * from "./vc-switch.vue?vue&type=script&lang=js&"
import style0 from "./vc-switch.vue?vue&type=style&index=0&id=08ff97c9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ff97c9",
  null
  
)

export default component.exports